// extracted by mini-css-extract-plugin
export var content = "accordion-module--content--3148e";
export var content__open = "accordion-module--content__open--d181a";
export var header = "accordion-module--header--f4e79";
export var header__open = "accordion-module--header__open--0cfb9";
export var icon = "accordion-module--icon--62458";
export var icon__rotated = "accordion-module--icon__rotated--cff5c";
export var item = "accordion-module--item--c8bd7";
export var spin = "accordion-module--spin--ce03d";
export var title = "accordion-module--title--1f161";